import React, { Component } from 'react'
import { Modal, Button, Select, DatePicker } from 'antd'
import { inject, observer } from 'mobx-react'
import { cancellationRequests, files } from '@services/api'
import download from '@utils/download'
import { fileExt } from '@texts/files'
import moment from 'moment'

@inject((store: any) => {
    const { popupStore, authStore } = store

    return {
        popupStore,
        authStore
    }
})
@observer
export default class GenerateCancellationReport extends Component<any> {
    constructor(props) {
        super(props)
        this.state = {
            filterType: 'created_at',
            start: undefined,
            end: undefined
        }
    }

    onClose = () => {
        this.setState(
            {
                start: undefined,
                end: undefined
            },
            () => {
                this.props.popupStore.togglePopup(false)
            }
        )
    }

    submit = () => {
        const { filterType, start, end } = this.state

        let payload = {
            filters: {
                type: filterType,
                start: start ? start.format('YYYY-MM-DD 00:00:00') : '2020-01-01 00:00:00',
                end: end ? end.format('YYYY-MM-DD 23:59:59') : moment().format('YYYY-MM-DD 23:59:59')
            }
        }

        cancellationRequests
            .generateCancellationReport(payload)
            .then(res => {
                const file = res.data
                if (file) this.downloadFile(file)
            })
            .catch(err => {
                alert('שגיאה בעת יצירת הקובץ')
            })
    }

    async downloadFile(file) {
        let downloadedFile = await files
            .assert(file.file_url)
            .then(res => new Blob([res.data], { type: fileExt[file.file_ext] }))
        download(downloadedFile)
    }

    render() {
        return (
            <Modal
                onCancel={this.onClose}
                visible={this.props.popupStore.popupType === 'GenerateCancellationReport'}
                title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative' }}>
                        <span>{'יצירת דו״ח ביטולים'}</span>
                        <Button onClick={() => this.setState({ start: undefined, end: undefined })}>{'איפוס'}</Button>
                    </div>
                }
                footer={null}
                width={'700px'}
            >
                <div style={{ ...style.column }}>
                    <div style={{ ...style.header }}>
                        <div style={{ ...style.filterCell }}>
                            <h6 style={{ ...style.filterLabel }}>לפי</h6>
                            <Select
                                defaultValue={'created_at'}
                                onChange={value => this.setState({ filterType: value })}
                            >
                                <Select.Option value={'created_at'}>תאריך פתיחת בקשה</Select.Option>
                                <Select.Option value={'cancelled_at'}>תאריך ביטול מינוי</Select.Option>
                            </Select>
                        </div>
                        <div style={{ ...style.filterCell }}>
                            <h6 style={{ ...style.filterLabel }}>מתאריך:</h6>
                            <DatePicker
                                value={this.state.start}
                                format={'DD/MM/YYYY'}
                                defaultValue={undefined}
                                onChange={e => this.setState({ start: e })}
                                disabledDate={current => current && current > moment().endOf('day')}
                                style={{ border: 'none' }}
                                allowClear={false}
                            />
                        </div>
                        <div style={{ ...style.filterCell }}>
                            <h6 style={{ ...style.filterLabel }}>עד תאריך:</h6>
                            <DatePicker
                                value={this.state.end}
                                format={'DD/MM/YYYY'}
                                defaultValue={undefined}
                                onChange={e => this.setState({ end: e })}
                                disabledDate={current => current && current > moment().endOf('day')}
                                style={{ border: 'none' }}
                                allowClear={false}
                            />
                        </div>
                        <Button style={{ alignSelf: 'end', marginBottom: '4px' }} onClick={this.submit}>
                            יצירת דו״ח
                        </Button>
                    </div>
                </div>
            </Modal>
        )
    }
}

const style = {
    column: { display: 'flex', flexDirection: 'column' },
    header: { display: 'flex', justifyContent: 'space-evenly', marginBottom: '30px' },
    filterCell: { display: 'flex', flexDirection: 'column' },
    filterLabel: { fontWeight: '500' }
}
